// extracted by mini-css-extract-plugin
export var layoutContainer = "e_bc_8";
export var positionLeft = "e_bc_cf";
export var positionRight = "e_bc_cg";
export var screenMobileL = "425px";
export var screenTablet = "768px";
export var sectionContainer = "e_bc_9";
export var textWrapper = "e_bc_bb";